import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'
import { AddressContainer, ImageContainer, InnerContainer } from './styles'
import { ReactComponent as LocationImg } from 'assets/TimeLocation/locationNew.svg'
import { IconFilled } from 'components/IconsContainers/styled'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { handleLocalStorage } from 'featureSliced/shared/hooks/handleLocalStorage'
import { formatPickupLocation } from './formatPickupLocation'

const isClickCollect = process.env.REACT_APP_IS_CLIC === '1'

export const Location = () => {
  const t = useTranslations()
  const color = useMySelector((state) => state.app.interfaceStyles.FontColor)
  const restaurants = useMySelector((state) => state.restaurants)
  // the same value the sidebar shows — restaurant-manager's Address → Phone
  const companyPhone = useMySelector((state) => state.app.companyData.Phone)

  const dataEnc = handleLocalStorage('dataEnc')
  const restaurant = restaurants?.find((rest) => rest?.dataEnc === dataEnc)

  return (
    <InnerContainer>
      <ImageContainer>
        <IconFilled color={color}>
          <LocationImg />
        </IconFilled>
      </ImageContainer>
      <AddressContainer>
        <p>{t('clickCollect.pickUpLocation')}:</p>
        <p>
          {formatPickupLocation({
            title: restaurant?.title,
            address: restaurant?.address,
            phone: isClickCollect ? companyPhone : null,
          })}
        </p>
      </AddressContainer>
    </InnerContainer>
  )
}
